import { PDFDocument, rgb } from "pdf-lib";
import * as fontkit from "fontkit";

export async function personalizePDF(arrayBuffer, name, results) {
  const pdfDoc = await PDFDocument.load(arrayBuffer);
  pdfDoc.registerFontkit(fontkit);

  const arialBytes = await fetch("/ARIAL.ttf").then(res => {
    if (!res.ok) throw new Error("ARIAL.ttf not found");
    return res.arrayBuffer();
  });
  const arialBoldBytes = await fetch("/ARIALBD.ttf").then(res => {
    if (!res.ok) throw new Error("ARIALBD.ttf not found");
    return res.arrayBuffer();
  });

  const arialFont = await pdfDoc.embedFont(arialBytes);
  const arialBoldFont = await pdfDoc.embedFont(arialBoldBytes);

  const pages = pdfDoc.getPages();

  const newName = name + ",";
  const firstPage = pages[0];

  firstPage.drawRectangle({
    x: 95,
    y: 420,
    width: 210,
    height: 30,
    color: rgb(1, 1, 1),
  });

  firstPage.drawText(newName, {
    x: 95,
    y: 427,
    size: 16,
    font: arialBoldFont,
    color: rgb(0, 0, 0),
  });

  const resultFontSize = 35;

  const coordinates = [
    { x: pages[1].getWidth() - 67, y: pages[1].getHeight() - 52 },
    { x: pages[2].getWidth() - 65, y: pages[2].getHeight() - 52 },
    { x: pages[3].getWidth() - 65, y: pages[3].getHeight() - 52 },
    { x: pages[4].getWidth() - 54, y: pages[4].getHeight() - 48 },
    { x: pages[5].getWidth() - 65, y: pages[5].getHeight() - 45 },
    { x: pages[6].getWidth() - 50, y: pages[6].getHeight() - 40 },
  ];

  for (let i = 1; i <= 6; i++) {
    const page = pages[i];
    const { x, y } = coordinates[i - 1];
    const value = String(results[i - 1]);

    // Смещение координаты x, если только 1 цифра
    const adjustedX = value.length > 1 ? x - 10 : x;

    page.drawText(value, {
      x: adjustedX,
      y,
      size: resultFontSize,
      font: arialBoldFont,
      color: rgb(0, 0, 0),
    });
  }

  const modifiedPdf = await pdfDoc.save();
  return new Blob([modifiedPdf], { type: "application/pdf" });
}
